import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadReturnIndentList = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.RETURN_INDENT_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const ReturnIndentCRUD = async (api, payload) => {
    try {       
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const loadIssuedIndentNumberListOnReturn = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.RETURN_INDENT_GET_ISSUED_NUMBER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}


export const loadReturnIndentCode = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.RETURN_INDENT_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadIssuedDetailForReturn = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.RETURN_INDENT_GET_ISSUE_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}